// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"4aa9d6e4","261":"f5dee7fa","331":"94dbeca2","526":"dcb758c6","595":"d21b7887","638":"d9a3e2e4"}[chunkId] + ".chunk.css";
};